import {bool, func, number, object} from 'prop-types';
import {useEffect, useState} from 'react';

import {useDeleteDayExercise} from '../api.js';
import {useExercisesById, useMutationCallback} from '../utils/hooks.js';
import {runAfterAnimations} from '../utils/misc.js';
import ConfirmDialog from './ui/ConfirmDialog.jsx';

export default function DeleteMesoDayExerciseDialog({dayId, dayExercise, isOpen, onClose}) {
  const deleteDayExercise = useDeleteDayExercise(dayId, dayExercise?.id);
  const exercisesById = useExercisesById();
  const [name, setName] = useState('');

  useEffect(() => {
    if (dayExercise) {
      if (!name || name !== exercisesById[dayExercise.exerciseId]?.name) {
        setName(exercisesById[dayExercise.exerciseId]?.name);
      }
    }
  }, [dayExercise, exercisesById, name]);

  const handleClose = useMutationCallback(onClose);

  const handleDeleteExercise = useMutationCallback(() => {
    if (dayExercise.id) {
      deleteDayExercise.mutate(null, {
        onSuccess: () => {
          onClose();
          runAfterAnimations(() => {
            setName('');
          });
        },
      });
    }
  }, [dayExercise, deleteDayExercise, onClose]);

  return (
    <ConfirmDialog
      title="Delete exercise?"
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleDeleteExercise}
      isLoading={deleteDayExercise.isWorking}
      description={`Are you sure you want to delete ${name} from your workout?`}
      message="Deleting an exercise from your workout will delete all of its sets, even if you've already completed them."
      variant="error"
    />
  );
}

DeleteMesoDayExerciseDialog.propTypes = {
  dayId: number.isRequired,
  dayExercise: object,
  isOpen: bool.isRequired,
  onClose: func.isRequired,
};
